export default __webpack_public_path__ + "static/media/phone.b8299349.svg";